module.exports = __webpack_public_path__ + "dash_20_app_assets/img/completesurvey.9c592f90.png";